module.exports = __webpack_public_path__ + "static/media/Ny-introduksjon-til-Ordforstaels.e25e2c34.mp3";